export default __webpack_public_path__ + "static/media/envialia.cf274952.svg";